export const data_extensions = {
    methods: {
        tryParseInt: function (str, defaultValue) {
            var retValue = parseInt(defaultValue);
            if (str && str.length > 0 && !isNaN(str)) {
                retValue = parseInt(str);
            }
            return retValue;
        },
        tryParseFloat: function (str, defaultValue) {
            var retValue = parseFloat(defaultValue);
            if (str && str.length > 0 && !isNaN(str)) {
                retValue = parseFloat(str);
            }
            return retValue;
        },
        sortNumbersInArrayAsc: function (array) {
            return array.sort((a, b) => a - b);
        },
        sortNumbersInArrayDesc: function (array) {
            return array.sort((a, b) => b - a);
        },
        toCurrency: function (value) {
            var precision = value.toString().split('.')[0].length + 2;
            return parseFloat(value.toPrecision(precision)).toFixed(2);
        },
        isStringNullOrEmpty(value) {
            if (value === undefined || value == null)
                return true;

            if (typeof value == 'string') {
                return (value == '' || value == 'undefined');
            }
            return;
        },
        toThousandSeparatedDisplayValue: function (x) {
            var parts = x.toString().split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return parts.join('.');
        }
    }
}